class Poller {
    constructor({pollingFn, onResult, initialDelay, loadingMessage, rootStore, message, action}) {
        this.rootStore = rootStore;
        this.pollingFn = pollingFn;
        this.onResult = onResult;
        this.initialDelay = initialDelay; // initial delay before first poll
        this.interval = 5000; // interval between subsequent polls
        this.timeout = 180000; // max time to poll (3 minutes)
        this.loadingMessage = loadingMessage;
        this.message = message;
        this.action = action;

        this.startPolling();
    }

    async startPolling() {
		const notificationId = this.rootStore.notificationStore.load(this.loadingMessage);
        // Initial longer delay
        await this.delay(this.initialDelay);

        const startTime = Date.now();
        let done = false;

        while (!done) {
            try {
                const result = await this.pollingFn();
                if (result) {
                    done = true;
                    this.onResult(result, this.message, this.action);
                } else {
                    if (Date.now() - startTime >= this.timeout) {
                        done = true;
                        break;
                    }
                    await this.delay(this.interval);
                }
            } catch (err) {
                done = true;
            }
        }

		this.rootStore.notificationStore.dismiss(notificationId);
    }

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}

export default Poller;
